import React, { useRef, useState } from "react";
import { Form, Alert } from "react-bootstrap";
import Button from "../../components/UI/Button/Button";
import { useAuth } from "../../contexts/AuthContext";
import { Link, useHistory } from "react-router-dom";
import Form__separator from "../../components/UI/Form/Form__separator/Form__separator";
import Section from "../../components/UI/Section/Section";

export default function Login() {
  const emailRef = useRef();
  const passwordRef = useRef();
  const { currentUser, login, signinGoogle } = useAuth();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  if (currentUser) history.push("/");

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      setError("");
      setLoading(true);
      await login(emailRef.current.value, passwordRef.current.value);

      history.push("/");
    } catch (e) {
      setError("Ошибка входа. Проверьте логин и пароль" );
      console.log(e);
      window.scrollTo(0, 0);
    }

    setLoading(false);
  }

  const handleInputChange = () => {
    setError("");
    setLoading(false);
  }

  async function googleSigninHandler(e) {
    e.preventDefault();
    try {
      setError("");
      setLoading(true);
      await signinGoogle();
      history.push("/check-user-data");
    } catch (e) {
      setError("Ошибка входа. Проверьте логин и пароль" );
      console.log(e);
      window.scrollTo(0, 0);
    }
  }

  return (
    <>
      {error && <Alert variant="danger">{error}</Alert>}
      <Form onSubmit={handleSubmit} className="Form Form_type_welcome-form">
        <h2 className="Heading Form__title">Вход</h2>
        <Form.Group id="email" className="Form__group" onChange={handleInputChange}>
          <Form.Label>Email</Form.Label>
          <Form.Control type="email" ref={emailRef} required />
        </Form.Group>
        <Form.Group id="password" className="Form__group">
          <Form.Label>Пароль</Form.Label>
          <Form.Control type="password" ref={passwordRef} required onChange={handleInputChange}/>
          <Link className="Form__link Form__helper-link" to="/forgot-password">
            Забыли пароль?
          </Link>
        </Form.Group>
        <Form.Group id="password" className="Form__group">
          <Button disabled={loading} className="Form__submit" type="submit">
            Войти
          </Button>
          <Button
            disabled={loading}
            className="Form__link"
            variant="link"
            onClick={googleSigninHandler}
          >
            Войти через Google
          </Button>
        </Form.Group>
        <Form.Group className="Form__group">
          <Form__separator />
        </Form.Group>
        <Link to="/signup" className="Form__link">
          Регистрация
        </Link>
      </Form>
      <Section>
        <p style={{opacity:0.5, margin: "28px 0 28px", textAlign:"center", fontSize:"14px", fontWeight: "300"}}>
          Продолжая использовать приложение, вы соглашаетесть с&nbsp;
          <Link to="/privacy" className="Form__link" style={{color:"inherit"}}>Политикой</Link>
        </p>
      </Section>
    </>
  );
}
